var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigStarIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 348 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.415 40.5994L198.406 3.89561C210.381 -15.2171 240.513 -4.48264 237.136 17.6989L230.651 60.2835C228.336 75.4863 243.228 87.7231 258.121 82.8502L299.835 69.201C321.56 62.094 337.594 89.2831 320.446 104.146L287.519 132.683C275.768 142.872 279.138 161.619 293.749 167.255L334.663 183.049C355.969 191.273 350.401 222.192 327.508 222.789L283.545 223.932C267.853 224.337 258.128 240.824 265.616 254.338L286.588 292.184C297.513 311.894 272.941 332.079 255.013 318.122L220.585 291.331C208.295 281.765 190.025 288.275 186.891 303.336L178.11 345.523C173.539 367.492 141.465 367.492 136.895 345.523L128.114 303.336C124.979 288.275 106.71 281.765 94.4203 291.331L59.9922 318.122C42.0634 332.073 17.4982 311.894 28.4168 292.184L49.3884 254.338C56.8773 240.83 47.1522 224.343 31.4596 223.932L-12.5035 222.789C-35.4031 222.192 -40.9706 191.273 -19.6579 183.049L21.2557 167.255C35.8598 161.619 39.237 142.872 27.4856 132.683L-5.44078 104.146C-22.5892 89.2831 -6.55559 62.094 15.1702 69.201L56.8839 82.8502C71.7699 87.7231 86.6691 75.4863 84.3542 60.2835L77.8686 17.6989C74.4914 -4.48264 104.624 -15.2171 116.599 3.89561L139.59 40.5994C147.794 53.7029 167.244 53.7029 175.448 40.5994H175.415Z",
    fill: "#C77EF5",
    fillOpacity: 0.7
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigStarIcon);
export default __webpack_public_path__ + "static/media/bigStar_icon.ab7b2981d5624831a583ecbc385fd9fe.svg";
export { ForwardRef as ReactComponent };